// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"bb404d3d","726":"64e9befd"}[chunkId] + ".chunk.js";
};